import { render, staticRenderFns } from "./printHandout.vue?vue&type=template&id=66685474&"
import script from "./printHandout.vue?vue&type=script&lang=js&"
export * from "./printHandout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./printHandout.vue?vue&type=custom&index=0&blockType=stlye&lang=scss"
if (typeof block0 === 'function') block0(component)

export default component.exports